var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-card',{attrs:{"loading":_vm.loading,"type":"bar","options":_vm.chartOptions,"series":_vm.series,"title":"Commanders Location"}})
}
var staticRenderFns = []

export { render, staticRenderFns }